// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton-module__backButton--MCj8p","backIcon":"BackButton-module__backIcon--U8dmd","notSafari":"BackButton-module__notSafari--pDGo_"};